import { Action } from 'services/action';

export const resetCountAction = new Action('@transaction/get-counts');
